import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import { CassarFeriasService } from "../../../services/CassarFeriasService";
import {TiposFeriasEnum } from "../../../constants";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import moment from "moment";

export default {
  name: "AnalisarCassacao",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  props: {
    selected: {
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    form: {},
    justificativaRecusa: "",
    actionsDialogt: false,
    exerciciosOptions: [],
    titulo: 'Analisar Cassação Férias',
    numeroDiasTitulo:'Número de dias úteis solicitados',
    numeroDiasCassadoTitulo: 'Número de dias úteis cassados',

    loading: {
      field: false,
      btn: false,
      btnRefuse: false
    }
  }),
async beforeMount(){
  this.inicializarModal()
  this.initializeForm();
  await this.getDataAnalise();
  this.$forceUpdate();

},
  watch: {
    isOpen: async function (isOpen) {
      if (isOpen) {
        this.inicializarModal()
        this.initializeForm();
        await this.getDataAnalise();
      }
    },
  },

  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.titulo = 'Analisar Cassação Férias Prêmio';
        this.numeroDiasTitulo = 'Número de dias corridos solicitados';
        this.numeroDiasCassadoTitulo = 'Número de dias corridos cassados';

      }else{
        this.titulo = 'Analisar Cassação Férias'
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
        this.numeroDiasCassadoTitulo = 'Número de dias úteis cassados';
      }
    },
    async getDataAnalise() {
      const response = await CassarFeriasService.getByIdFerias(this.selected.idFerias);
      this.form.justificativa = response.justificativa 
      this.form.dataInicioCassados = response.data_ini 
      this.form.dataFimCassados  = response.data_fin
      this.form.numeroDiasCassados = response.dias 
    },

   
    prepareForm() {
        const formData = new FormData();

        this.sendForm(formData);
        return;
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await CassarFeriasService.aprovarCassacaoFerias(this.selected.idFerias, formData);
      this.loading.btn = false;
      if (response) {
        this.$refs.form.reset();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    calculateFinalDate() {
      const finalDate = moment(this.form.dataInicio).add(this.form.numeroDias, 'days');
      if (this.form.dataInicio) {
        this.form.dataFim = moment(finalDate).format("YYYY-MM-DD");
        return;
      }
      SnackBarModule("Prencha o campo de data inicial", "error");
    },

    initializeForm() {
      this.form = {
        justificativa: null,
        dataInicio: this.selected.dataIni,
        dataFim: this.selected.dataFin,
        numeroDias: this.selected.numeroDias,
        numeroDiasCassados: "",
        dataInicioCassados: "",
        dataFimCassados:"",
      }
    },

    async refuse() {
      const formData = new FormData();
      formData.append("justificativa_recusa", this.justificativaRecusa);

      this.loading.btnRefuse = true;
      const response = await CassarFeriasService.recusarCassacaoFerias(this.selected.idFerias, formData);
      this.loading.btnRefuse = false;
      if (response) {
        this.justificativaDialog = false;
        this.close();
      }
    },

    close() {
      this.$emit("on-close");
    },
    openActionsDialog() {
      this.actionsDialogt = true;
    },
    closeActionsDialog() {
      this.actionsDialog = false;
      this.getFerias();
    }
  }
};